var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.17.14a.8.8,0,0,0-.72-.1,5.83,5.83,0,0,0-.08,11.19.83.83,0,0,0,.79-.07.87.87,0,0,0,.37-.74V8.26h1v2.16a.87.87,0,0,0,.37.74.84.84,0,0,0,.47.15.65.65,0,0,0,.25,0A5.83,5.83,0,0,0,13.7.06a.83.83,0,0,0-.78.09.87.87,0,0,0-.36.73V3h-1V.88A.87.87,0,0,0,11.17.14ZM13,4.43a1,1,0,0,0,1-1V1.64a4.43,4.43,0,0,1,0,8V7.87a1,1,0,0,0-1-1H11.15a1,1,0,0,0-1,1V9.65a4.43,4.43,0,0,1,0-8V3.42a1,1,0,0,0,1,1Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,19.77a.7.7,0,0,0-.7.7V23.3a.7.7,0,0,0,1.39,0V20.47A.7.7,0,0,0,17.8,19.77Z",
    fill: "#e30613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13.07H8a6.28,6.28,0,0,0-6.17,6.35V23.3a.7.7,0,0,0,1.39,0V19.42a4.89,4.89,0,0,1,4.78-5h8a4.89,4.89,0,0,1,4.78,5V23.3a.7.7,0,0,0,1.39,0V19.42A6.28,6.28,0,0,0,16,13.07Z",
    fill: "#e30613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2,19.77a.7.7,0,0,0-.7.7V23.3a.7.7,0,0,0,1.39,0V20.47A.7.7,0,0,0,6.2,19.77Z",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokProfile);
export default __webpack_public_path__ + "static/media/hok-profile.4412c54dd0f3a08b39ce8907f1c8684c.svg";
export { ForwardRef as ReactComponent };